import React from 'react';
import { Row, Col, Form, Card } from 'react-bootstrap';

/**
 * Araç formlarında kullanılan Detaylı Teknik Özellikler formu
 * 
 * @param {Object} props.data - Form verisi (formData veya vehicle)
 * @param {Function} props.handleChange - Input değişikliklerini yakalayan fonksiyon
 */
const VehicleDetailedTechnicalForm = ({ data, handleChange }) => {
    return (
        <Card className="mb-4">
            <Card.Header>Detaylı Teknik Özellikler</Card.Header>
            <Card.Body>
                <h6 className="mb-3">Genel Özellikler</h6>
                <Row>
                    <Col md={4}>
                        <Form.Group className="mb-3">
                            <Form.Label>Hızlanma (0-100 km/saat)</Form.Label>
                            <Form.Control
                                type="text"
                                name="generalFeatures.acceleration"
                                value={data.generalFeatures?.acceleration || ''}
                                onChange={handleChange}
                                placeholder="Örn: 6,6sn"
                            />
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        <Form.Group className="mb-3">
                            <Form.Label>Motor Gücü</Form.Label>
                            <Form.Control
                                type="text"
                                name="generalFeatures.enginePower"
                                value={data.generalFeatures?.enginePower || ''}
                                onChange={handleChange}
                                placeholder="Örn: 258HP"
                            />
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        <Form.Group className="mb-3">
                            <Form.Label>Azami Sürat</Form.Label>
                            <Form.Control
                                type="text"
                                name="generalFeatures.maxSpeed"
                                value={data.generalFeatures?.maxSpeed || ''}
                                onChange={handleChange}
                                placeholder="Örn: 250km/saat"
                            />
                        </Form.Group>
                    </Col>
                </Row>

                <h6 className="mb-3 mt-4">Motor ve Performans</h6>
                <Row>
                    <Col md={4}>
                        <Form.Group className="mb-3">
                            <Form.Label>Maksimum Güç</Form.Label>
                            <Form.Control
                                type="text"
                                name="engineDetails.power"
                                value={data.engineDetails?.power || ''}
                                onChange={handleChange}
                                placeholder="Örn: 258 hp (190 kw) / 6.500 rpm"
                            />
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        <Form.Group className="mb-3">
                            <Form.Label>Motor Hacmi</Form.Label>
                            <Form.Control
                                type="text"
                                name="engineDetails.volume"
                                value={data.engineDetails?.volume || ''}
                                onChange={handleChange}
                                placeholder="Örn: 1998cc"
                            />
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        <Form.Group className="mb-3">
                            <Form.Label>Maksimum Tork</Form.Label>
                            <Form.Control
                                type="text"
                                name="engineDetails.torque"
                                value={data.engineDetails?.torque || ''}
                                onChange={handleChange}
                                placeholder="Örn: 400 Nm / 4.400 rpm"
                            />
                        </Form.Group>
                    </Col>
                </Row>

                <h6 className="mb-3 mt-4">Yakıt Tüketimi</h6>
                <Row>
                    <Col md={4}>
                        <Form.Group className="mb-3">
                            <Form.Label>Yakıt Depo Hacmi</Form.Label>
                            <Form.Control
                                type="text"
                                name="fuelConsumption.tankCapacity"
                                value={data.fuelConsumption?.tankCapacity || ''}
                                onChange={handleChange}
                                placeholder="Örn: 68lt"
                            />
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        <Form.Group className="mb-3">
                            <Form.Label>Şehir İçi Tüketim</Form.Label>
                            <Form.Control
                                type="text"
                                name="fuelConsumption.cityConsumption"
                                value={data.fuelConsumption?.cityConsumption || ''}
                                onChange={handleChange}
                                placeholder="Örn: 8,8lt"
                            />
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        <Form.Group className="mb-3">
                            <Form.Label>Şehir Dışı Tüketim</Form.Label>
                            <Form.Control
                                type="text"
                                name="fuelConsumption.highwayConsumption"
                                value={data.fuelConsumption?.highwayConsumption || ''}
                                onChange={handleChange}
                                placeholder="Örn: 6,4lt"
                            />
                        </Form.Group>
                    </Col>
                </Row>

                <h6 className="mb-3 mt-4">Boyutlar</h6>
                <Row>
                    <Col md={4}>
                        <Form.Group className="mb-3">
                            <Form.Label>Lastik Ölçüleri</Form.Label>
                            <Form.Control
                                type="text"
                                name="dimensions.tireSize"
                                value={data.dimensions?.tireSize || ''}
                                onChange={handleChange}
                                placeholder="Örn: 245/40 R20 99 Y"
                            />
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        <Form.Group className="mb-3">
                            <Form.Label>Yükseklik</Form.Label>
                            <Form.Control
                                type="text"
                                name="dimensions.height"
                                value={data.dimensions?.height || ''}
                                onChange={handleChange}
                                placeholder="Örn: 1538mm"
                            />
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        <Form.Group className="mb-3">
                            <Form.Label>Uzunluk</Form.Label>
                            <Form.Control
                                type="text"
                                name="dimensions.length"
                                value={data.dimensions?.length || ''}
                                onChange={handleChange}
                                placeholder="Örn: 5091mm"
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                        <Form.Group className="mb-3">
                            <Form.Label>Bagaj Kapasitesi</Form.Label>
                            <Form.Control
                                type="text"
                                name="dimensions.luggageCapacity"
                                value={data.dimensions?.luggageCapacity || ''}
                                onChange={handleChange}
                                placeholder="Örn: 600lt"
                            />
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        <Form.Group className="mb-3">
                            <Form.Label>Yüksüz Ağırlık</Form.Label>
                            <Form.Control
                                type="text"
                                name="dimensions.emptyWeight"
                                value={data.dimensions?.emptyWeight || ''}
                                onChange={handleChange}
                                placeholder="Örn: 1860kg"
                            />
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        <Form.Group className="mb-3">
                            <Form.Label>Yüklü Ağırlık</Form.Label>
                            <Form.Control
                                type="text"
                                name="dimensions.loadedWeight"
                                value={data.dimensions?.loadedWeight || ''}
                                onChange={handleChange}
                                placeholder="Örn: 2450kg"
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                        <Form.Group className="mb-3">
                            <Form.Label>Genişlik</Form.Label>
                            <Form.Control
                                type="text"
                                name="dimensions.width"
                                value={data.dimensions?.width || ''}
                                onChange={handleChange}
                                placeholder="Örn: 1902mm"
                            />
                        </Form.Group>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};

export default VehicleDetailedTechnicalForm;